<template>
  <div class="filterWrapper textSearch">
    <div class="content">
      <div
        class="floating-placeholder lgrid-noWrap"
        :class="{focused: search || focused}"
      >
        <div class="lgrid-column-noGutter-center-noWrap-equalHeight lcol">
          <div
            class="placeholder"
            @click="focus"
          >
            {{ name }}
          </div>
          <input
            ref="textInput"
            v-model.lazy="tempSearch"
            type="text"
            :name="id"
            @focus="focus"
            @blur="blur"
            @submit="submit"
            @keydown="lastSearchValue = null"
            @keyup.enter="submit"
          >
        </div>
        <button
          v-if="enabledResetButton"
          class="no-button textSearch--submit"
          @click="search = ''"
        >
          <i class="dsio-close" />
        </button>
        <button
          v-if="!enabledResetButton"
          class="no-button textSearch--submit"
          @click="() => { !tempSearch ? focus() : submit() }"
        >
          <i class="dsio-search-light" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import baseEngines from './baseEngines';

export default {
  name: 'TextSearch',
  mixins: [baseEngines],
  props: {
    name: {
      type: String,
      default: '',
    },
    requestValue: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      focused: false,
      lastSearchValue: null,
      tempSearch: null,
    };
  },
  computed: {
    enabledResetButton () {
      if (this.search) {
        return !this.focused || this.search === this.lastSearchValue;
      }
      return false;
    },
    search: {
      get () {
        return this.filterData || '';
      },
      set (value) {
        this.filterData = this.lastSearchValue = value;

        this.updateContext(value ? [{ id: value, name: value }] : '');
      },
    },
  },
  watch: {
    search (val) {
      this.tempSearch = val;
    },
  },
  created () {
    // If requestValue is not empty
    if (this.requestValue !== null) {
      // Restore selection
      this.search = this.requestValue;
    }
  },
  methods: {
    focus () {
      this.focused = true;
      this.$refs.textInput.focus();
    },
    blur () {
      this.focused = false;
    },
    submit () {
      this.search = this.tempSearch;
    },
  },
};
</script>
